import { defineComponent as _defineComponent } from 'vue'
import { onUnmounted, ref } from "vue";
import { SHOW_NOTIFICATION_TIME } from "@/configs/global";
import SvgClose from "@/assets/icons/close.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'LimitNotification',
  setup(__props, { expose }) {

const isShow = ref(false);
const text = ref('');
let timer: ReturnType<typeof setTimeout> | null = null;

const clearTimer = (): void => {
    if (timer) {
        clearTimeout(timer);
        timer = null;
    }
};

const hide = (): void => {
    isShow.value = false;
    clearTimer();
};

// Показать уведомление; повторный вызов перезапускает таймер автоскрытия
const show = (message: string): void => {
    text.value = message;
    isShow.value = true;
    clearTimer();
    timer = setTimeout(hide, SHOW_NOTIFICATION_TIME);
};

onUnmounted(clearTimer);

expose({ show });

return { __sfc: true,isShow, text, timer, clearTimer, hide, show, SvgClose }
}

})